//Entry point js dell'applicazione

import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import VueKeyCloak from "@dsb-norge/vue-keycloak-js";
import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";
import VueFormWizard from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import "vue-material/dist/vue-material.min.css";
import config from "./config/keycloakConfig";
import moment from "moment";
import MobileDeviceDetect from "mobile-device-detect";
import i18n from "./i18n";

function isES6() {
  try {
    //**** Syntax ****
    //default function parameters
    eval("function foo (dummy = 1) {}");
    //spread syntax
    eval("Math.max(...[ 1, 2 ])");
    //template literals
    eval("var dummy = `dummy`");
    //destructuring assignment
    eval(
      "var { dummyOne: o, dummyTwo: t } = { dummyOne: 'dummyOne', dummyTwo: 'dummyTwo' }"
    );

    //**** Bindings ****
    //const statement
    eval("const a = 1");
    //let statement
    eval("let a = 1");

    //**** Functions ****
    //arrow functions
    eval("var f = x => 1");
    //class statement
    eval("class Foo {}");
    //generators
    eval("function* foo() {}");

    //**** Misc ****
    eval("async function foo () {}");

    return (
      typeof Array.prototype.find !== "undefined" &&
      typeof Array.prototype.findIndex !== "undefined" &&
      typeof Array.from !== "undefined" &&
      typeof Array.of !== "undefined" &&
      typeof Array.prototype.entries !== "undefined" &&
      typeof Array.prototype.keys !== "undefined" &&
      typeof Array.prototype.copyWithin !== "undefined" &&
      typeof Array.prototype.fill !== "undefined" &&
      typeof Object.assign !== "undefined" &&
      typeof Object.setPrototypeOf !== "undefined" &&
      typeof Object.getOwnPropertySymbols !== "undefined" &&
      typeof Object.is !== "undefined" &&
      typeof Map !== "undefined" &&
      typeof WeakMap !== "undefined" &&
      typeof Set !== "undefined" &&
      typeof WeakSet !== "undefined" &&
      typeof Promise !== "undefined" &&
      typeof Symbol !== "undefined" &&
      typeof Symbol.for === "function"
    );
  } catch (exception) {
    return false;
  }
}

function isDeviceAllowed() {
  return (
    !MobileDeviceDetect.isSmartTV &&
    !MobileDeviceDetect.isWearable &&
    !MobileDeviceDetect.isConsole
  );
}

function isBrowserAllowed() {
  let browserAllowed = true;

  //scommentare qualora ci sia bisogno di controllare la versione del browser

  //TODO: C'È BISOGNO DI UN CONTROLLO DELLA VALORIZZAZIONE DI MobileDeviceDetect.browserVersion:
  //      COSA FARE SE NON DOVESSE ESSERE VALORIZZATO?
  // let browserVersion = parseInt(MobileDeviceDetect.browserVersion);

  // if (
  //   (MobileDeviceDetect.isChrome && browserVersion < 51) ||
  //   (MobileDeviceDetect.isFirefox && browserVersion < 54) ||
  //   (MobileDeviceDetect.isEdge && browserVersion < 16) ||
  //   (MobileDeviceDetect.isSafari && browserVersion < 10) ||
  //   (MobileDeviceDetect.isOpera && browserVersion < 38)
  // )
  //   browserAllowed = false;

  return browserAllowed;
}

function showError(errorMessage, subErrorMessage) {
  document.write(
    "<div style='background-color: white; height: 100px; padding: 10px'>" +
      "  <img src='logo.png' style='width: auto; height: 80px;' alt='logo uVote'/>" +
      "</div>" +
      "" +
      "<div style='color: red; margin-top: 50px; text-align: center;'>" +
      "  <img src='warning.png' />" +
      "  <div>" +
      "    <h1>" +
      errorMessage +
      "</h1>" +
      (subErrorMessage ? "<h2>" + subErrorMessage + "</h2>" : "") +
      "  </div>" +
      "</div>"
  );
}

//se il browser supporta ECMA Script 6 (2015)
if (isES6()) {
  console.log(
    "Browser: " +
      MobileDeviceDetect.browserName +
      " Version: " +
      MobileDeviceDetect.fullBrowserVersion +
      "\nOS: " +
      MobileDeviceDetect.osName +
      " VerMobileDeviceDetectsion: " +
      MobileDeviceDetect.osVersion +
      "\nDevice Type: " +
      MobileDeviceDetect.deviceType
  );

  //controlla che il dispositivo utilizzato sia supportato
  if (!isDeviceAllowed()) {
    showError(
      "Questo dispositivo non &egrave; supportato",
      "Si prega di utilizzare un altro dispositivo"
    );
  }
  //controlla che il browser utilizzato sia supportato
  else if (!isBrowserAllowed()) {
    showError(
      "Questo browser non &egrave; supportato",
      "Si prega di utilizzare un altro browser o di aggiornarlo"
    );
  }
  //lancia l'app
  else {
    Vue.prototype.moment = moment;
    Vue.config.productionTip = false;

    Vue.use(VueKeyCloak, {
      onReady: keycloak => {
        new Vue({
          el: "#app",
          store,
          template: "<App/>",
          i18n,
          render: h => h(App)
        }).$mount("#app");
      },
      config: config,
      init: {
        onLoad: "login-required"
      },
      logout: {
        redirectUri: process.env.https://uvote.cineca.it/
      }
    });

    Vue.use(VueMaterial);
    Vue.use(VueFormWizard);
  }
} else {
  showError(
    "Questo browser non &egrave; supportato",
    "Si prega di utilizzare un altro browser o di aggiornarlo"
  );
}
